.pageDiv1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 10px;
  align-items: center;
  justify-content: center;
}
